import { CampaignBriefProductsState } from "./campaign-brief-products.interface";

export const createCampaignBriefProductsState = (): CampaignBriefProductsState => ({
  errors: null,
  loading: false,
  products: [],
});
